import config from 'config'

export function getCertificateDownloadUrl(certificateNumber) {
  return `${config.env.GRAPHQL_API_URL}/certificate/${certificateNumber}`
}

export default {
  getCertificateDownloadUrl,
}
